export class BeatCode {
  constructor(tempo = 120, frameRate = 30) {
    this.tempo = tempo
    this.frameRate = frameRate
  }

  get beatsPerSecond() {
    const t = Math.max(1e-6, this.tempo)
    return t / 60
  }

  get framesPerNote() {
    return (this.frameRate / this.beatsPerSecond) * 4
  }

  noteFraction(type) {
    const notes = {
      whole: 1.0,
      half: 0.5,
      quarter: 0.25,
      eighth: 0.125,
      sixteenth: 0.0625,
    }
    const f = notes[type]
    if (f == null) throw new Error(`Unknown note type: ${type}`)
    return f
  }

  framesFor(type) {
    return this.framesPerNote * this.noteFraction(type)
  }

  secondsFor(type) {
    return this.framesFor(type) / this.frameRate
  }

  framesForSequence(type, count) {
    return this.framesFor(type) * count
  }

  secondsForSequence(type, count) {
    return this.secondsFor(type) * count
  }

  secondsPerQuarter() {
    return this.secondsFor('quarter')
  }

  framesPerQuarter() {
    return this.framesFor('quarter')
  }

  toFramesFromBeats(beats) {
    return (this.frameRate / this.beatsPerSecond) * beats
  }

  toSecondsFromBeats(beats) {
    return beats / this.beatsPerSecond
  }

  setTempo(t) {
    this.tempo = t
  }

  setFrameRate(fps) {
    this.frameRate = fps
  }
}

export const makeBeatCode = (settings) => new BeatCode(settings.bpm, settings.fps)


